import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiToken, analyticsOrgBackendUrl } from '../utils/config';

export const fetchOrgAnalytics = createAsyncThunk(
  'analytics/fetchOrgAnalytics',
  async ({ startDate, endDate, organizationId }, thunkAPI) => {
    const getStepGranularity = (startDate, endDate) => {
      const diffInMs = new Date(endDate) - new Date(startDate);
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      if (diffInDays > 365 * 100) return "century";
      if (diffInDays > 365 * 10) return "decade";
      if (diffInDays > 365 * 2) return "year";
      if (diffInDays > 90) return "month";
      if (diffInDays > 60) return "month";
      if (diffInDays > 29) return "week";
      if (diffInDays > 2) return "day";
      if (diffInDays > 0.083) return "hour"; 
      if (diffInDays > 0.0014) return "minute"; 
      return "second";
    };

    const step = getStepGranularity(startDate, endDate);

    try {
      const response = await fetch(analyticsOrgBackendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${apiToken}`,
        },
        body: JSON.stringify({
          startDate,
          endDate,
          step,
          organizationId, 
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        return thunkAPI.rejectWithValue(error.message || 'Failed to fetch analytics');
      }

      const data = await response.json();
    
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue('Something went wrong');
    }
  }
);

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    data: [],
    loading: false,
    error: null,
    status: 'idle',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrgAnalytics.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(fetchOrgAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchOrgAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default analyticsSlice.reducer;
